/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import ReactCountryFlag from 'react-country-flag';

export function getFlagImg(element) {
  if (element && element.initial && element.initial !== 'NN') {
    return (
      <ReactCountryFlag
        countryCode={element.initial}
        svg
        style={{
          width: '3em',
          height: '2em',
          paddingLeft: '20px',
        }}
      />
    );
  }

  return (<div />);
}

export function getFlagWithText(element) {
  let flag = (<div />);
  if (element && element.initial && element.initial !== 'NN') {
    flag = (
      <ReactCountryFlag
        countryCode={element.initial}
        svg
        style={{
          width: '3em',
          height: '2em',
          paddingLeft: '20px',
        }}
      />
    );
  }
  const itemWithFlag = (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}
    >
      <span>{element.name ? element.name : ''}</span>
      {flag}
    </div>
  );
  return itemWithFlag;
}

export function getFlagWithTextReverse(element) {
  let flag = (<div />);
  if (element && element.initial && element.initial !== 'NN') {
    flag = (
      <ReactCountryFlag
        countryCode={element.initial}
        style={{
          fontSize: '1.5em',
          paddingLeft: '20px',
        }}
      />
    );
  }
  const itemWithFlag = (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}
    >
      <span style={{ marginRight: '10px', minWidth: '50px' }}>
        {flag}
      </span>
      <span>{element.name ? element.name : ''}</span>
    </div>
  );
  return itemWithFlag;
}
